<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="签约统计" :header-visible="true" :back-visible="true" :user-list-lock.sync="userListLock" controller="h5" action="sayer" :title-type-lock="false"/><!--参数都可以不传-->
    <scroll-refresh>
      <div class="tools-wrap wap-channel-wrap">
        <div class="rows-div">
          <div class="top-info-area">
            <span class="s_title">
              签约统计
            </span>
            <span class="s_right">
              <font v-if="chartsSort.options.length">排序</font>
              <el-select
                v-model="chartsSort.value"
                placeholder="请选择排序方式"
                size="mini"
                v-if="chartsSort.options.length"
                @change="setChartsSort">
                <el-option
                  v-for="item in chartsSort.options"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select>
              <el-button :class="screenBtnStyle ? 'active' : ''" type="primary" @click="showFilter">筛选</el-button>
            </span>
          </div>
          <div class="chart-div">
            <bi-bar-line
              :data="chartsData.data"
              :data1="chartsData.data1"
              :options="chartsData.options"
              :refresh="chartsData.refresh"
              @reload="initCharts"/>
          </div>
        </div>
        <div class="channel-list-wrap2">
          <data-list :url="url"
                     :search-data="searchData"
                     :refresh.sync="refresh"
                     :refresh-lock="true">
            <template slot-scope="{ item, index, header, refresh }">
              <div class="channel-list-special">
                <div>{{ item.teacher }}</div>
                <div><span>{{ header.fenpei.label }}</span><span>{{ item.fenpei }}</span></div>
                <div><span>{{ header.qianyue.label }}</span><span>{{ item.qianyue }}</span></div>
                <div><span>{{ header.zhuanhua.label }}</span><span>{{ item.zhuanhua }}</span></div>
              </div>
            </template>
          </data-list>
        </div>
      </div>
    </scroll-refresh>
    <popup-filter :show-lock.sync="showFilterLock" :search-data.sync="searchData" :search-ds="searchDsUrl">
      <el-button slot="close-button" @click="closePopupFilter" class="btn-close-popup-fullpage"><font>×</font></el-button>
    </popup-filter>
  </div>
</template>
<script>
import header from '@/pages/h5/compoments/header';
import scrollRefresh from '@/pages/h5/compoments/scrollRefresh';
import BiBarLine from '@/components/charts/biBarLine';
import popupFilter from './compoments/popupFilter';
import common from '@/pages/bi/common';
import dataList from '@/pages/h5/compoments/dataList';

export default {
  data() {
    return {
      userListLock: true,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      showFilterLock: false,
      searchData: {
        gid: '',
        year: '0',
        month: [],
        teacher_id: [],
        timeline: [],
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: '',
        },
        roleid: ''
      },
      url: '/index/bi.teacher/getSayerPage',
      searchDsUrl: '/index/bi.teacher/searchDs',
      screenBtnStyle: false,
    };
  },
  components: {
    'wap-header': header,
    scrollRefresh,
    BiBarLine,
    popupFilter,
    dataList
  },
  mixins: [common],
  methods: {
    init() {
      this.refresh = true;
      this.initCharts();
    },
    initCharts() {
      this.fetchData({
        url: '/index/b_i_teacher2020/getSayerTeacherChart',
        field: 'chartsData',
        param: this.searchData,
        option: {
          margin: {
            top: 50, right: 30, bottom: 30, left: 0
          },
          colors: ['#4F5DE0', '#67DCFF', '#FF7B69', '#FFAF66'],
          barWidth: 24,
          defaultBarWidth: 60,
          labelWidthPercent: 100 / 4,
          domainType: 'string',
          groupType: true,
          exY1: '%',
          helpLine: true,
          fontSize: 14,
        },
        sort: 'chartsSort'
      });
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    closePopupFilter() {
      this.showFilterLock = false;
    },
    showFilter() {
      this.showFilterLock = true;
    },
  },
  watch: {
    showFilterLock(v) {
      if (!v) {
        this.$nextTick(this.init);
        this.refresh = true;
      }
      if (this.searchData.teacher_id.length > 0
          || this.searchData.timeline.length > 0
          || this.searchData.year === '0'
          || this.searchData.month.length > 0) {
        this.screenBtnStyle = true;
      } else {
        this.screenBtnStyle = false;
      }
    }
  },
  mounted() {
    this.$http
      ._get({
        url: this.searchDsUrl
      })
      .then(({ data }) => {
        this.searchData.roleid = typeof data.roleids === 'object' ? data.roleids[0].roleid : data.roleids;
        this.init();
      });
  }
};
</script>
<style scoped>
</style>
